<script setup>
import { storeToRefs } from 'pinia'
import { en } from 'primelocale/js/en.js'
import { es } from 'primelocale/js/es.js'
import { usePrimeVue } from 'primevue/config'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import { setToast } from '@/services/toast'

import log from '@/logger'
import { useUserStore } from '@/stores/user.js'

import AppTopbar from './AppTopbar.vue'

const store = useUserStore()
const primevue = usePrimeVue()
const { locale } = useI18n()
// lang.value is the same as store.lang
const { dark, lang } = storeToRefs(store)

// make toast available from other parts of application that are outside of
// setup() function (like api.js)
setToast(useToast())

// State synchronization with localStorage. It can also be done by using a
// plugin like "pinia-plugin-persistedstate" but can be implemented easily with
// Pinia's subscribtions and localStorage's events.

/** Save state to localStorage on any state mutation in Pinia store */
store.$subscribe((_ /*mutation*/, state) => {
  localStorage.setItem('userStore', JSON.stringify(state))
  log('info', 'Pinia state saved to userStorage')
})
store.$subscribe((_ /*mutation*/, state) => {
  localStorage.setItem('userStore', JSON.stringify(state))
  log('info', 'Pinia state saved to userStorage')
})

/** Load state from localStorage to Pinia store if there is anything saved */
function loadState() {
  const storageData = localStorage.getItem('userStore')
  log('info', 'Searching previous state in localStorage')
  if (storageData) {
    const state = JSON.parse(storageData)
    log('info', 'State found in localStorage, loading to Pinia:', state)
    store.$state = state
  }
}

// load state if it exists on start of application or page reload
loadState()

// load state whenever data localStorage changes from another window or tab
window.addEventListener('storage', (event) => {
  if (event.key === 'userStore') {
    loadState()
  }
})

// Apply dark mode when activated in Pinia state
watch(
  dark,
  () => {
    if (dark.value) {
      document.documentElement.classList.add('my-app-dark')
      // document.documentElement.classList.toggle('my-app-dark')
    } else {
      document.documentElement.classList.remove('my-app-dark')
    }
  },
  { immediate: true }
)

// Update UI locale when changed in Pinia state
watch(
  lang,
  () => {
    // set Vue-i18n language
    locale.value = lang.value
    // set Primevue language
    const languages = { en, es }
    primevue.config.locale = languages[lang.value]
    // primevue.config.locale = 'es-ES'
  },
  { immediate: true }
)

// Show version of the application
const version = import.meta.env.VERSION
const release_date = import.meta.env.RELEASE_DATE
console.log('Marga version', version)
</script>

<template>
  <div class="min-h-screen flex-1 flex flex-col">
    <header>
      <app-topbar></app-topbar>
    </header>
    <!-- sidebar, if needed -->

    <!-- <main class="min-h-screen flex-1 m-auto md:w-11/12 my-3"> -->
    <main class="flex-1 mx-3 sm:mx-10 my-3">
      <!-- sdfk sdkfjh jhsd sads dsfhkjssdfcerckjhs dsf -->
      <RouterView />
      <!--
      <div class="flex gap-4 mt-6 p-3 bg-surface-200">
        <p>Debug dark: {{ store.dark }}</p>
        <ToggleButton v-model="dark" class="w-24" on-label="Dark" off-label="Light" />
        <Select id="lang" v-model="lang" :options="availableLocales" />
      </div>
      -->
    </main>

    <footer class="bg-surface-600 dark:bg-surface-200 text-surface-200 dark:text-surface-600 p-6">
      <span class="mr-6">Marga - Versión {{ version }}. {{ release_date }}</span>
      <!-- <RouterLink to="/about">Sobre esta aplicación</RouterLink> -->
      <!-- TODO: debug info -->
      <!--
      <p>Debug i18n: {{ t('nav.home') }}</p>
      <p>Locale: {{ locale }}, available: {{ availableLocales }}</p>
      -->
    </footer>
    <Toast />
  </div>
</template>

<style scoped></style>
